export default "__VITE_ASSET__BfQTMsQi__"